// src/main.js
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import './assets/styles.scss';
import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // MUST be the bundle version
import DataTable from 'datatables.net-vue3';
import DataTablesLib from 'datatables.net-bs5';
// Datatables extensions with BS5 integration
import 'datatables.net-responsive-bs5';
import 'datatables.net-fixedcolumns-bs5';
import 'datatables.net-colreorder-bs5';
import 'datatables.net-select-bs5';

// Datatables CSS for BS5
import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.css';
import 'datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.css';

import tooltipDirective from '@/directives/tooltip';

import App from '@/App.vue';
import router from '@/router';

import { isProd, devUserId } from '@/utils/config';

DataTable.use(DataTablesLib); // Register it here once

async function init() {
  const app = createApp(App);
  app.directive('tooltip', tooltipDirective);
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  app.use(pinia);
  localStorage.removeItem('auth');

  if (!isProd && devUserId) {
    console.warn(`Mocking auth as: ${devUserId}`);
  }

  // Mount app
  app.use(router);
  await router.isReady();
  app.mount('#app');
}

// Start the app using async waits
init();
